import { CUSTOMER_TYPE_AMAZON_DSP } from './constants';

export const getShortCodeRules = (customerType) => {
    if (customerType === CUSTOMER_TYPE_AMAZON_DSP) {
        return [
            { required: true, message: 'Please introduce a short code', trigger: ['blur', 'change'] },
            { validator: (rule, value, callback) => {
                if (value && !value.trim()) callback(new Error('Short code cannot contain only spaces'));
                else callback();
            }, trigger: ['blur', 'change'] }
        ];
    }
    return [];
};
